import { createFileRoute, Link, Outlet, useLocation } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/app/forecasting")({ component: ForecastingLayout });

const TABS: ReadonlyArray<{ to: string; label: string; exact?: boolean }> = [
  { to: "/app/forecasting", label: "Overview", exact: true },
  { to: "/app/forecasting/suggestions", label: "PO suggestions" },
  { to: "/app/forecasting/policies", label: "Reorder Policies" },
  { to: "/app/forecasting/alerts", label: "Stockout Alerts" },
];

function ForecastingLayout() {
  const loc = useLocation();
  return (
    <>
      <div className="border-b bg-card">
        <div className="px-4 sm:px-6 pt-3 flex items-center gap-1 overflow-x-auto">
          {TABS.map((t) => {
            const active = t.exact ? loc.pathname === t.to : loc.pathname.startsWith(t.to);
            return (
              <Link key={t.to} to={t.to as never}
                className={cn(
                  "px-3 py-2 text-sm rounded-t border-b-2 -mb-px",
                  active ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:text-foreground",
                )}>
                {t.label}
              </Link>
            );
          })}
        </div>
      </div>
      <Outlet />
    </>
  );
}